import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-zone',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Combustible</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">        
        <ul #subnav app-nav-tanques [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex mb-3">
          <div class="flex-fill ms-2">
            <h2 class="mt-2 mt-md-0 mb-0">Zona</h2>
            <p class="text-muted" style="font-size: 14px;">Crea una zona de distribución.</p>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5">
          <div class="list-group-item table-responsive py-4">
            <app-form-zone 
              [zone]="zone" 
              [roles]="roles" 
              (updateZone)="saveZone($event)"
            ></app-form-zone>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class CreateZoneComponent implements OnInit {
  zoneId: number = 0;
  zone: any = {};
  roles: any = [];
  currentView: string = 'zones';

  constructor(
    private store: SettlementsService,
    private route: Router,
    private activateRoute: ActivatedRoute,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) { 
    this.activateRoute.params.subscribe(params => {
      this.zoneId = params['id'];
      this.loadZone(this.zoneId);
    });

    this.store.getRoles({}).subscribe({
      next: (data: any) => {
        this.roles = data;
      },
      error: (error: any) => {}
    });
  }

  ngOnInit(): void {}

  loadZone(id: number) {
    this.store.getZone(id).subscribe({
      next: (data: any) => {
        console.log("data => ", data);
        this.zone = data;
        // this.buildForm();
      },
      error: (error: any) => {}
    });
  }

  saveZone(zone: any) {
    console.log('zone!!!! => ', zone);
    this.store.createZone(zone).subscribe({
      next: (data: any) => {
        console.log('data => ', data);
        this.toastr.success('Éxito', 'Zona creada correctamente.');
      },
      error: (error: any) => {
        console.log('error => ', error);
        this.toastr.error('Error', 'Ocurrió un error al actualizar la zona');
      }
    });
  }

}
